export const slideTermsEnabled: boolean = false;
